import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { useAuth } from './context/AuthContext';
import { LabelProvider } from './context/LabelContext';
import { ThemeProvider as CustomThemeProvider, useTheme } from './context/ThemeContext';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/Auth/LoginPage';
import SignupPage from './pages/Auth/SignupPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import SpacesPage from './pages/Spaces/SpacesPage';
import SpaceDetailPage from './pages/Spaces/SpaceDetailPage';
import SecretDetailPage from './pages/Secrets/SecretDetailPage';
import LabelsPage from './pages/Labels/LabelsPage';
import LabelDetailPage from './pages/Labels/LabelDetailPage';
import ProfilePage from './pages/Profile/ProfilePage';
import LoadingSpinner from './components/UI/LoadingSpinner';
import { GlobalStyles } from './styles/GlobalStyles';
import { MobileFixes } from './styles/MobileFixes';
import { initializeMobileViewportFix, addMobileViewportClass } from './utils/mobileViewportFix';
import { useEffect } from 'react';

// Component that uses the theme context
function AppContent() {
  const { user, loading } = useAuth();
  const { theme } = useTheme();
  
  // Initialize mobile viewport fixes
  useEffect(() => {
    initializeMobileViewportFix();
    addMobileViewportClass();
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <MobileFixes />
      <Routes>
        {/* Public routes */}
        <Route
          path="/login"
          element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />}
        />
        <Route
          path="/signup"
          element={user ? <Navigate to="/dashboard" replace /> : <SignupPage />}
        />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            user ? (
              <LabelProvider>
                <Layout>
                  <Routes>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/spaces" element={<SpacesPage />} />
                    <Route path="/spaces/:id" element={<SpaceDetailPage />} />
                    <Route path="/secrets/:id" element={<SecretDetailPage />} />
                    <Route path="/labels" element={<LabelsPage />} />
                    <Route path="/labels/:id" element={<LabelDetailPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </Layout>
              </LabelProvider>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

function App() {
  return (
    <CustomThemeProvider>
      <AppContent />
    </CustomThemeProvider>
  );
}

export default App;
